import { render } from "./TreeSelect.vue?vue&type=template&id=61a964d2&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"

import "./TreeSelect.vue?vue&type=style&index=0&id=61a964d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a964d2"]])

export default __exports__